const faqs = [
  {
    q: '妖精动漫网真的完全免费吗？',
    a: '是的，妖精动漫网所有漫画均可免费在线阅读，无需付费订阅。我们通过合规的广告合作维持运营，绝不会向读者收取任何阅读费用，真正做到免费漫画大全。',
  },
  {
    q: '什么是下拉式阅读？如何使用？',
    a: '下拉式阅读是一种创新的漫画浏览方式，你只需像刷短视频一样向下滑动屏幕，漫画内容就会连续展示，无需频繁点击翻页。在手机、平板或电脑上都能流畅使用，极大提升阅读沉浸感。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '热门连载漫画通常与日本同步更新，中文汉化版在日文原版发布后24小时内上线。我们拥有专业的汉化合作团队，确保翻译质量与更新速度。部分周刊漫画每周固定日期更新，月刊漫画每月更新。',
  },
  {
    q: '支持哪些设备阅读？需要下载APP吗？',
    a: '妖精动漫网是网页端平台，无需下载任何APP。你可以在手机浏览器、平板和电脑上直接访问阅读，所有设备自动适配最佳显示效果。关注微信公众号也可以快速进入阅读页面。',
  },
  {
    q: '如何找到我想看的漫画？',
    a: '你可以通过首页的专题合集、热门话题标签浏览漫画，也可以使用搜索功能按漫画名称、作者或类型查找。我们还提供分类筛选和排行榜功能，帮你快速发现感兴趣的作品。',
  },
  {
    q: '漫画画质如何？支持什么阅读模式？',
    a: '所有漫画均提供高清画质，支持日漫标准从右向左的阅读方向。默认采用下拉式连续阅读模式，也支持传统翻页模式。你可以根据个人习惯自由切换阅读方式，获得最舒适的体验。',
  },
];

export default function Faq() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-2 text-center">
          常见问题
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">关于妖精动漫网，你想知道的都在这里</p>

        <div className="space-y-4">
          {faqs.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6">
              <h3 className="font-heading font-bold text-base text-foreground-900 mb-2 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">Q</span>
                {item.q}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed pl-7">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}